import React from "react";
import { cn } from "../../../utils/cn";

const Toggle = ({
  label,
  checked,
  onChange,
  disabled = false,
  className = "",
}) => {
  return (
    <button
      type="button"
      onClick={() => !disabled && onChange(!checked)}
      disabled={disabled}
      className={cn(
        "flex items-center justify-between w-full p-3 bg-muted/30 border rounded-lg font-fira text-xs transition-all duration-200 group text-left",
        checked
          ? "border-primary/50 bg-primary/5 terminal-glow text-foreground"
          : "border-border hover:border-muted-foreground/30 text-muted-foreground",
        disabled && "opacity-40 cursor-not-allowed",
        className
      )}
    >
      <span className="font-semibold uppercase tracking-wider group-hover:text-foreground transition-colors duration-150">
        {label}
      </span>
      <div className="flex items-center space-x-2">
        <span className={cn(
          "font-bold text-[10px]",
          checked ? "text-primary" : "text-muted-foreground"
        )}>
          {checked ? "ON" : "OFF"}
        </span>
        {/* Glow LED Indicator */}
        <div
          className={cn(
            "w-2.5 h-2.5 rounded-full border transition-all duration-300",
            checked
              ? "bg-primary border-primary shadow-[0_0_8px_var(--color-primary)] animate-pulse"
              : "bg-muted border-border"
          )}
        />
      </div>
    </button>
  );
};

export default Toggle;
